import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BenutzermanagementAPIService } from '../../api/benutzermanagement/benutzermanagement-api.service';
import { AppToastService } from '../../toast/app-toast.service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

@Component({
  selector: 'san-novitas-bkkhksinformation-popup',
  templateUrl: './novitas-bkkhksinformation-popup.component.html',
  styleUrls: ['./novitas-bkkhksinformation-popup.component.scss'],
  standalone: false,
})
export class NovitasBKKHKSInformationPopupComponent implements OnInit {
  static ID = 'Novitas BKK HKS Information';
  bestaetigen = false;

  constructor(
    private activeModal: NgbActiveModal,
    private bmClient: BenutzermanagementAPIService,
    private toastService: AppToastService,
    private http$: HttpClient,
    private router: Router,
  ) {}

  ngOnInit(): void {}

  alsGelesenMarkieren() {
    this.activeModal.dismiss();
    this.bmClient
      .setPopupViewed(NovitasBKKHKSInformationPopupComponent.ID, false)
      .subscribe();
  }

  alsWeggeklicktMarkieren() {
    if (this.bestaetigen) {
      this.alsGelesenMarkieren();
    }
    this.activeModal.dismiss();
    this.bmClient
      .setPopupViewed(NovitasBKKHKSInformationPopupComponent.ID, true)
      .subscribe();
  }

  geheZuVertraegen() {
    this.router.navigate(['/', 'versorgungsvertraege', 'vertraege']);
  }

  schliessen(bestaetigen: boolean) {
    if (bestaetigen) {
      this.alsGelesenMarkieren();
    } else {
      this.alsWeggeklicktMarkieren();
    }
  }
}
